export default __webpack_public_path__ + "static/media/paloateparo3.e3760499.jpg";